module.exports = __webpack_public_path__ + "static/media/pilotly-logo-white-sm.046f4096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pilotly-logo-white-sm.png
// module id = 611
// module chunks = 0